import type { MixCreate } from "src/store/api/generatedApi";

export const emptyFurnaceAndThresholds = (): Required<
  Pick<MixCreate, "furnace" | "thresholds">
> => ({
  furnace: [],
  thresholds: null,
});
